import { z } from 'zod';

export type AssignmentCountsQuery = z.infer<typeof assignmentCountsQuerySchema>;

export const assignmentCountsQuerySchema = z.object({
  assigned: z.stringbool().optional(),
  createdAfter: z.iso.datetime().optional(),
  createdBefore: z.iso.datetime().optional(),
  ignored: z.stringbool().optional(),
  root: z.stringbool().optional(),
});
